export const visit = (vm, at) => {
at({ "no-no": { "conversations-visitor-experience-components": { "code-splitting": { "error": { "title": "Det oppsto et problem med nettverksforbindelsen.", "message": "Sjekk tilkoblingen og pr\xF8v igjen.", "button": "Pr\xF8v igjen" } } } } });
};